import { CircularProgress, Stack, Typography } from '@mui/material';
import type { RoleCountResult } from './hooks/use-role-count';
import { useTranslations } from '@/i18n/use-translations';
import type { EventContributorRole } from '@/types/dtos/contributors/response/contributor.dto';

export const RoleProgressCounters = ({ roleHeatmap }: { roleHeatmap: RoleCountResult['roleHeatmap'] }) => {
  const t = useTranslations();
  if (Object.entries(roleHeatmap).length === 0) return null;

  return (
    <Stack spacing={1} sx={{ mt: 1 }}>
      {Object.entries(roleHeatmap).map(([role, { accepted, total }], i) => {
        const progress = (accepted / total) * 100;
        return (
          <Stack
            key={role}
            data-testid={`role-progress-counter-${role}-${i}`}
            direction="row"
            justifyContent="space-between"
            sx={{ pl: 1 }}
          >
            <Typography variant="body2" color="text.secondary">
              {t(`common.roleLabels.${role as EventContributorRole}`)}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body2" color="text.secondary">
                {`${accepted} ${t('common.of')} ${total} ${t('common.confirmed')}`}
              </Typography>
              <CircularProgress variant="determinate" color="info" value={progress} size={16} />
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
